<template>
  <div class="register">
    <form @submit.prevent="registerForm">
      <h2>Register for our Virtual Event</h2>
      <div class="section" v-if="currentSection === 1">
        <div class="formField" v-for="item in fields.slice(0,3)" :key="item.id" :class="{ error : item.error, errorValidField : item.errorValidField}">
          <label :for="item.name">{{ item.label }}</label>
          <input :type="item.type" :name="item.name" :id="item.name" :placeholder="item.placeholder" v-model="item.value">
          <p class="error">Error this field is required</p>
          <p class="errorValidField">Please enter a valid Email Address</p>
        </div>
        <div class="formActions">
          <button type="button" @click="registerNext()">Next</button>
          <button type="button" @click="gotoLogin()">Go back</button>
        </div>
      </div>
      <div class="section" v-if="currentSection === 2">
        <div class="formField" v-for="item in fields.slice(3,5)" :key="item.id" :class="{ error : item.error, errorValidField : item.errorValidField}">
          <label :for="item.name">{{ item.label }}</label>
          <input :type="item.type" :name="item.name" :id="item.name" :placeholder="item.placeholder" v-model="item.value">
          <p class="error">Error this field is required</p>
          <p class="errorValidField">Please enter a valid Email Address</p>
        </div>
        <div class="formField checkbox">
          <input type="checkbox" name="personalData" id="personalData" v-model="personalData">
          <label for="personalData">I consent to Ultimaker using my personal data for the purpose of this Virtual Event.</label>
        </div>
        <div class="formField checkbox">
          <input type="checkbox" name="terms" id="terms" v-model="policies">
          <label for="terms">I agree to the <a href="/">Terms &amp; Conditions</a> and <a href="/">Privacy</a></label>
        </div>
        <div class="formActions">
          <p class="error" v-if="customError">{{ customError }}</p>
          <button type="submit">Register</button>
          <button type="button" @click="gotoLogin()">Go back</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
var i;

export default {
  name: "Register",
  components: {

  },
  data: () => ({
    errors: false,
    currentSection: 1,
    fields: [
      {id: 1, name: "firstname", label: "First name*", type: "text", placeholder: "Enter your first name...", value: "", error: false},
      {id: 2, name: "lastname", label: "Last name*", type: "text", placeholder: "Enter your last name...", value: "", error: false},
      {id: 3, name: "emailAddress", label: "Email address*", type: "text", placeholder: "Enter your email address...", value: "", error: false, errorValidField: false},
      {id: 4, name: "phoneNumber", label: "Phone number*", type: "number", placeholder: "Enter your phone number...", value: "", error: false},
      {id: 5, name: "organisation", label: "Company*", type: "text", placeholder: "Enter your company...", value: "", error: false}
    ],
    personalData: false,
    policies: false,
    customError: ''
  }),
  methods: {
    registerForm(){
      this.error = false
      this.errorFailedLogin = false
      this.customError = ''
      for (i = 0; i < this.fields.length; i++) {
        this.fields[i].error = false
        this.fields[i].errorValidField = false
      }
      for (i = 0; i < this.fields.length; i++) {
        if(this.fields[i].value === ''){
          this.error = true
          this.fields[i].error = true
          return;
        } else if(this.fields[i].id === 3){
          if(!this.validEmail(this.fields[i].value)){
            this.error = true
            this.fields[i].errorValidField = true
            return;
          }
        }
      }
      if(this.error === false){
        const Body = {
          firstname: this.fields[0].value,
          lastname: this.fields[1].value,
          email: this.fields[2].value,
          phone: this.fields[3].value,
          organization: this.fields[4].value,
          personalData: this.personalData,
          policies: this.policies
        }
        this.$http({
          method: 'post',
          url: this.$store.state.api.auth + 'Register',
          data: Body,
        })
        .then(response => {
          localStorage.setItem('token', response.data.loginToken);
          console.log(response)
          // localStorage.setItem('token', 'placeholder');
          location.reload();
        })
        .catch(err => {
          this.customError = err.response.data
        });
      }
    },
    registerNext(){
      this.error = false
      this.errorFailedLogin = false
      for (i = 0; i < this.fields.length; i++) {
        this.fields[i].error = false
        this.fields[i].errorValidField = false
      }
      for (i = 0; i < this.fields.length; i++) {
        if(this.fields[i].id <= 3){
          if(this.fields[i].value === ''){
            this.error = true
            this.fields[i].error = true
            return;
          } else if(this.fields[i].id === 3){
            if(!this.validEmail(this.fields[i].value)){
              this.error = true
              this.fields[i].errorValidField = true
              return;
            }
          }
        }
      }
      if(this.error === false){
        this.currentSection = 2
        return false
      }
    },
    gotoLogin(){
      this.currentSection = 1
      for (i = 0; i < this.fields.length; i++) {
        this.fields[i].value = ''
      }
      this.$store.commit('authController/authControllerCommit', {
        currentSelection: 'Login'
      })
    },
    validEmail(value) {
      // eslint-disable-next-line
      let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
      // eslint-disable-next-line
      return re.test(value.toLowerCase());
    },
  },
  created() {

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Auth/Register";
</style>
